import {Registration} from "./registration";

export class Message {
  public id: string;
  public name: string;
  public code: string;
  public subject: string;
  public content: string;
  public roleRegistrations: Registration[];
  public messageType: string;
  public channel: string = "EMAIL";
}
